module.exports = __webpack_public_path__ + "img/04-1-1接入数据.bad7c40d.svg";